import { render, staticRenderFns } from "./CounterpartyAddressForm.vue?vue&type=template&id=1206a021&"
import script from "./CounterpartyAddressForm.vue?vue&type=script&lang=js&"
export * from "./CounterpartyAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports